export default __webpack_public_path__ + "static/aggielee1-a914a761ae111f421c133a09a851cf76.jpg";